import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { getDescendants } from '@/api/bauDoTesouro';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import ReportViewOne from '@/themes/themeOne/report/reportView.vue';
import ReportViewTwo from '@/themes/themeTwo/report/reportView.vue';
import { useTreasureActivityStore } from '@/stores/treasure';
import { computed, onMounted, ref } from 'vue';
import { DataList, ReportData } from './supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'reportView',
  setup(__props) {

const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const themeStore = useThemeStore()

const checked = ref(false)
const descendantsList = ref<DataList[]>([])
const activityStore = useTreasureActivityStore()
const rechargeRequire = computed(() => activityStore.rechargeRequire);
const turnoverRequire = computed(() => activityStore.turnoverRequire);
const ipLimit = computed(() => activityStore.ipLimit);

const switchClick = () => {
    checked.value = !checked.value
    getDescendantsList()
}
const dataSet = computed<ReportData>(() => ({
    rechargeRequire: rechargeRequire.value,
    turnoverRequire: turnoverRequire.value,
    ipLimit: ipLimit.value,
    checked: checked.value,
    descendantsList: descendantsList.value,
}))
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getDescendantsList = () => {
    loadingRef.value.open()
    let data = {
        is_effective: checked.value ? 1 : 0,
        page_num: 1,
        page_size: 20
    }
    getDescendants(data).then(res => {
        loadingRef.value.close()
        let resData = res.data.rows[0]
        descendantsList.value = resData.descendants

    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}

onMounted(() => {
    getDescendantsList()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ReportViewOne, {
            "data-set": dataSet.value,
            onSwitchClick: switchClick
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ReportViewTwo, {
            "data-set": dataSet.value,
            onSwitchClick: switchClick
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})